import React from 'react'

export default function PersonalInfo() {
    return (
        <div className="contaPersonal">
        <h5>Full Name : </h5>
        <h6>Mostafa Abd El-Azeem Abd El-Fattah</h6>
        <h5>Marital Status : </h5>
        <h6>Single</h6>
        <h5>Date of Birth : </h5>
        <h6>25/11/1994</h6>
        <h5>Military Status : </h5>
        <h6>Exempted</h6> 
        <h5>Address : </h5>
        <h6>Al-Haram Giza,Egypt</h6> 
        <h5>Education : </h5> 
        <h6 style={{margin: '0px'}}>Bachelor of Commerce</h6>
        <h6>Ain Shams University, Egypt</h6>
        <h6 style={{marginTop: '-14px'}}>Open Education System (Till Now)</h6>
    </div>
    )
}
